import { Head } from 'vite-react-ssg'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { articles, featuredArticle } from '../data/articles'

// Prerendered to dist/404.html and served by nginx via `error_page 404 /404.html`.
// Before this existed, nginx ended try_files at /index.html, so every unknown URL
// returned HTTP 200 with the homepage: a site-wide soft-404. See
// original-savage/notes/Original Savage Heartbeat.md.
const recent = [featuredArticle, ...articles].slice(0, 5)

export default function NotFound() {
  return (
    <div className="os-root">
      <Head>
        <title>Page Not Found · Original Savage</title>
        <meta name="description" content="That page doesn't exist. Head back to the dispatch archive." />
        <meta name="robots" content="noindex" />
      </Head>
      <Header />
      <main id="main">
        <section className="wrap sec art-detail">
          <h1>Off the map</h1>
          <div className="article-body">
            <p>
              There's nothing at this address. Either the link was wrong, or something moved and we didn't leave a
              forwarding note. Both are fixable from here.
            </p>
            <h2>Try one of these</h2>
            <ul>
              <li>
                <Link to="/articles">The full dispatch archive</Link>, which is the fastest way to find what you were after.
              </li>
              <li>
                <Link to="/">The front page</Link>, if you'd rather start over.
              </li>
            </ul>
            <h2>Recent dispatches</h2>
            <ul>
              {recent.map((a) => (
                <li key={a.slug}>
                  <Link to={`/articles/${a.slug}`}>{a.title}</Link>
                </li>
              ))}
            </ul>
            <p>
              If you followed a link from somewhere on this site and landed here, that's our bug and we'd like to know:{' '}
              <a href="mailto:contact@originalsavage.com">contact@originalsavage.com</a>.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
